import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../services/global/global.service';
import { Meta } from '@angular/platform-browser';
import {MatDialog } from '@angular/material/dialog';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  url = this.global.mediasUrl;
  slides = [
    {img: "assets/medias/img/caroussel1.webp"},
    {img: "assets/medias/img/caroussel2.webp"},
    {img: "assets/medias/img/caroussel3.webp"},
  ];
  urlSafe: SafeResourceUrl;
  
  constructor(private global: GlobalService, private meta: Meta, private dialog: MatDialog, public sanitizer:DomSanitizer) {
    this.meta.addTag({
      name: 'description',
      content: 'A data platform to facilitate medical device clinical trials. Ensure high-quality data. Reduce study build time.'
    });
    this.meta.addTag({ name: 'author', content: 'ClinSearch' });
    this.meta.addTag({ name: 'keywords', content: 'CRO, EDC, ISO, 9001, research, medical, EDClin, ClinSearch' });
    this.meta.addTag({ property: 'og:title', content: 'A data platform to facilitate medical device clinical trials.' });
    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:image', content: 'assets/media/img/thumbnail.webp'});
    this.meta.addTag({ property: 'og:url', content: 'http://www.edclin.com/' });
    this.meta.addTag({ name: 'twitter:card', content: 'A data platform to facilitate medical device clinical trials.' });
   }

  ngOnInit() {
    // window.addEventListener('scroll', this.onScroll, true);
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.getRandomVideo());
  }

  getRandomVideo() {
    let index = Math.floor(Math.random() * 2) + 1 -1;
    return `https://www.youtube.com/embed/videoseries?list=PLtRBx11MrqiM0gOaHc2QtC6qTK0KgEEdR&loop=1&index=${index}&autoplay=1&mute=1&loop=1&modestbranding=1&showinfo=0&rel=0&iv_load_policy=3&theme=light&fs=0&controls=0`
  }

}
